// extracted by mini-css-extract-plugin
export default {"searchBoxContainer":"SearchInputWrapper__searchBoxContainer___qsJc6"};